import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar/Sidebar.tsx";
import type { Invoice } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";
import type { QuotaWithRelations } from "~/modules/quota/api/quota/quotaTypes.ts";
import {
	DetachQuotaInvoiceForm,
} from "~/modules/quota/components/QuotaDetailsView/components/DetachQuotaInvoiceSidebar/DetachQuotaInvoiceForm.tsx";
import { invalidateQuotaInvoiceChangeQueries } from "~/modules/quota/utils/quotaCacheUtils.ts";

type Props = {
	// The invoice to detach. The sidebar is open while it is set.
	invoice: Invoice | null;
	onClose: () => void;
	quota: QuotaWithRelations;
};

export const DetachQuotaInvoiceSidebar = ({ invoice, onClose, quota }: Props) => {
	const queryClient = useQueryClient();

	const handleSuccess = useCallback(async () => {
		await invalidateQuotaInvoiceChangeQueries(queryClient, quota);
		onClose();
	}, [onClose, queryClient, quota]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={!!invoice}
				 setOpen={onClose}>
			{invoice && <DetachQuotaInvoiceForm invoice={invoice}
												onCancel={onClose}
												onSuccess={handleSuccess}
												quota={quota} />}
		</Sidebar>
	);
};
